import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { Link, useHistory } from "react-router-dom";
import NoDataFound from "components/NoDataFound";
import { handleError } from "utils";
import { showSuccess } from "services/toast.service";
import RemoveButton from "components/Button/RemoveButton";
import Loader from "components/Loader";
import UpdateButton from "components/Button/UpdateButton";
import { API_BASE_URL } from "config/constants";
import { getAccessToken } from "utils";
import { ROLES } from "config/roles";
import { getUser } from "utils";

const Websites = ({ color }) => {
  const data = [];
  const history = useHistory();
  const [website, setwebsite] = useState(data);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedWebsiteId, setSelectedWebsiteId] = useState(0);
  const [gettingData, setGettingData] = useState(false);
  const [keyword, setKeyword] = useState("");
  const user = getUser();

  const getWebiste = async () => {
    try {
      setGettingData(true);
      const responce = await axios.get(`${API_BASE_URL}/website?page=1`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: getAccessToken(),
        },
      });

      setGettingData(false);

      const apiData = responce.data;
      setwebsite(apiData.result.data.result);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };

  useEffect(() => {
    getWebiste();
  }, []);

  //Delete

  const DeleteWebsite = async (id) => {
    try {
      setSelectedWebsiteId(id);
      setDeleteLoading(true);
      const deleteResponse = await axios.delete(`${API_BASE_URL}/website`, {
        headers: {
          "Content-Type": "application/json",
          authorization: getAccessToken(),
        },
        data: {
          id: id,
        },
      });

      setSelectedWebsiteId(0);
      setDeleteLoading(false);
      showSuccess(deleteResponse?.data?.result?.message);
      getWebiste();
    } catch (error) {
      setSelectedWebsiteId(0);
      setDeleteLoading(false);
      handleError(error);
    }
  };

  const goToUpdateData = (data) => {
    history.push("/admin/update-website", {
      data,
    });
  };

  const filterData = (data) => {
    if (!keyword) return true;
    if (data.name.toLowerCase().includes(keyword.toLowerCase())) {
      return true;
    }
    return false;
  };

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
  };
  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative flex justify-items-start gap-2 items-center w-full px-4 max-w-full flex-grow flex-1">
              {" "}
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                All Websites
              </h3>
              <Loader loading={gettingData} />
            </div>
            {![ROLES.Advertizer, ROLES.Publisher].includes(user.role) && (
              <Link to="/admin/add-website">
                <button
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                >
                  Add New Website
                </button>
              </Link>
            )}
          </div>
        </div>

        <div className="flex px-4 pb-3">
          <input
            type="text"
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full lg:w-1/3 ease-linear transition-all duration-150"
            placeholder="Search.."
            name="clicks"
            value={keyword}
            onChange={handleKeywordChange}
          />
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Website Name
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Created On
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Updated On
                </th>
                {/* <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Actions
                </th> */}
              </tr>
            </thead>
            <tbody>
              {website[0] ? (
                <>
                  {website.filter(filterData).map((web) => {
                    return (
                      <tr key={web._id}>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <span
                            className={
                              "ml-3 font-bold " +
                              +(color === "light"
                                ? "text-blueGray-600"
                                : "text-white")
                            }
                          >
                            {web.name}
                          </span>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {moment(web.createdAt).format("llll")}
                            </span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {moment(web.updatedAt).format("llll")}
                            </span>
                          </div>
                        </td>

                        {/* <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <UpdateButton onClick={() => goToUpdateData(web)} />

                            <RemoveButton
                              onClick={() => DeleteWebsite(web._id)}
                              loading={
                                deleteLoading && selectedWebsiteId === web._id
                              }
                            />
                          </div>
                        </td> */}
                      </tr>
                    );
                  })}
                </>
              ) : (
                <td colSpan={13}>
                  <NoDataFound />
                </td>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Websites;
